import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import moment from 'moment';
import leftPad from 'left-pad';

var formatTime = function formatTime(time) {
	return moment(time, 'HH:mm').format('HHmmP');
};

var formatDay = function formatDay(day) {
	return { Dia: leftPad(day, 2, '0') };
};

export var calculateHorario = function calculateHorario(schedule, initTime, endTime) {
	var range = [];
	var hours = { HoraA: formatTime(endTime), HoraDe: formatTime(initTime) };

	for (var i = 0; i < schedule.length; i++) {
		if (schedule[i] > -1) {
			range.push(_extends({}, formatDay(i + 1), hours));
		}
	}
	return range;
};

export var calculateUbigeo = function calculateUbigeo(form) {
	var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'commercialAddress';

	return '' + form.businessData[field].department.UbiDep + form.businessData[field].province.UbiPro + form.businessData[field].district.UbiDis;
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/shared.js
// module id = ./src/mappers/shared.js
// module chunks = 34